import React from "react";
import applicant from "../../../../assets/images/applicant.png";
import coapplicant from "../../../../assets/images/coapplicant.png";
import { Card, CardBody, Button } from "reactstrap";
export default function Kyc(props) {
  const { applicationDetails, bankSelfieData, isExpanded, setIsExpanded } =
    props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "30px",
      }}
    >
      <Card
        style={{
          border: "solid",
          borderRadius: "10px",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ marginTop: "10px" }}>
          <div
            style={{
              marginLeft: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "40px",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <img
                style={{ height: "33px", width: "33px" }}
                src={applicant}
                alt="applicant"
              />
              <p
                style={{
                  marginLeft: "20px",
                  fontFamily: "Inter-Medium",
                  color: "#232323",
                  marginTop: "13px",
                  fontWeight: "500",
                }}
              >
                Applicant
              </p>
            </div>
            
          </div>
          <div
            style={{
              borderTop: "0.75px solid #DBDBDB",
              margin: "10px 0",
            }}
          ></div>
        </div>
        <div style={{ paddingLeft: "20px" }}>
          <CardBody>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Aadhar Number
                  </strong>
                  <span
                    style={{
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile.userDetails.aadhaar
                      ? applicationDetails.profile.userDetails.aadhaar
                      : "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Bank Account
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {bankSelfieData?.bankDetails?.accountNumber || "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    PAN Number
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile.userDetails.pan
                      ? applicationDetails.profile.userDetails.pan
                      : "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    IFSC Code
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {bankSelfieData?.bankDetails?.ifsc || "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Beneficiary Name
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "15px" : "30px",
                      display: "block",
                      width: "100%",
                      wordBreak: "break-word",
                    }}
                  >
                    {bankSelfieData?.bankDetails?.beneficiaryName || "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Verified Name
                  </strong>
                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "15px" : "30px",
                      display: "block",
                      width: "100%",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile.userDetails.name
                      ? applicationDetails.profile.userDetails.name
                      : "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    C-KYC
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails
                      ? applicationDetails.profile.ckycAvailable
                        ? "Available"
                        : "NIL"
                      : null}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "calc(50% - 10px)",
                  marginBottom: "20px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    DigiLocker
                  </strong>
                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {bankSelfieData
                      ? bankSelfieData.digilockerDetailsAvailable
                        ? "Available"
                        : "NIL"
                      : null}
                  </span>
                </p>
              </div>
            </div>
          </CardBody>
        </div>
        <div
          style={{
            borderTop: "0.75px dashed #DBDBDB",
            margin: "10px 0",
          }}
        ></div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            marginRight: "10px",
          }}
        >
          <div>
            <p style={{ display: "flex", flexDirection: "column" }}>
              <strong
                style={{
                  color: "gray",
                  fontFamily: "Inter-Medium",
                  marginRight: "30px",
                  fontWeight: "400",
                  lineHeight: "10px",
                  fontSize: "13px",
                }}
              >
                Face Match
              </strong>

              <span>
                {" "}
                {bankSelfieData?.bankDetails?.facematchScore || "-------"}
              </span>
            </p>
          </div>
          <div>
            <p style={{ display: "flex", flexDirection: "column" }}>
              <strong
                style={{
                  color: "gray",
                  fontFamily: "Inter-Medium",
                  fontWeight: "400",
                  lineHeight: "10px",
                  fontSize: "13px",
                }}
              >
                Face Liveness
              </strong>
              <span>
                {bankSelfieData &&
                bankSelfieData.selfieDetails &&
                bankSelfieData.selfieDetails.faceLivenessScore
                  ? `${
                      Math.round(
                        (bankSelfieData.selfieDetails.faceLivenessScore +
                          Number.EPSILON) *
                          10000
                      ) / 100
                    } %`
                  : "-------"}
              </span>
            </p>
          </div>
          <div>
            <p style={{ display: "flex", flexDirection: "column" }}>
              <strong
                style={{
                  color: "gray",
                  fontFamily: "Inter-Medium",
                  fontWeight: "400",
                  lineHeight: "10px",
                  fontSize: "13px",
                }}
              >
                Name Match
              </strong>
              <span>
                {bankSelfieData &&
                bankSelfieData.bankDetails &&
                bankSelfieData.bankDetails.matchPercentage
                  ? `${bankSelfieData.bankDetails.matchPercentage} %`
                  : "-------"}
              </span>
            </p>
          </div>
        </div>
      </Card>
      {applicationDetails ? (
        Object.keys(applicationDetails?.coapplicantProfile?.userDetails)?.length > 0 ? (
          <Card
            style={{
              border: "solid",
              borderRadius: "10px",
              borderWidth: "1px",
              borderColor: "#DBDBDB",
              width: "100%",
              height: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <div
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  height: "40px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{ height: "33px", width: "33px" }}
                    src={coapplicant}
                    alt="coapplicant"
                  />
                  <p
                    style={{
                      marginLeft: "20px",
                      fontFamily: "Inter-Medium",
                      color: "#232323",
                      marginTop: "13px",
                      fononcltWeight: "500",
                    }}
                  >
                    Co-Applicant
                  </p>
                </div>
            
              </div>
              <div
                style={{
                  borderTop: "0.75px solid #DBDBDB",
                  margin: "10px 0",
                }}
              ></div>
            </div>
            <div style={{ paddingLeft: "20px" }}>
              <CardBody>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      height: "60px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Aadhar Number
                      </strong>
                      <span
                        style={{
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails
                          .aadhaar
                          ? applicationDetails.coapplicantProfile.userDetails
                              .aadhaar
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      height: "60px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Bank Account
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {bankSelfieData?.bankDetails?.accountNumber ||
                          "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        PAN Number
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails.pan
                          ? applicationDetails.coapplicantProfile.userDetails
                              .pan
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        IFSC Code
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {bankSelfieData?.bankDetails?.ifsc || "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Beneficiary Name
                      </strong>
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "15px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {bankSelfieData?.bankDetails?.beneficiaryName ||
                          "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        Verified Name
                      </strong>
                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "15px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile.userDetails.name
                          ? applicationDetails.coapplicantProfile.userDetails
                              .name
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        C-KYC
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails.coapplicantProfile.ckycAvailable
                          ? "Available"
                          : "NIL"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      flex: "0 0 calc(50% - 20px)",
                      minWidth: "220px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        DigiLocker
                      </strong>
                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {bankSelfieData
                          ? bankSelfieData.digilockerDetailsAvailable
                            ? "Available"
                            : "NIL"
                          : null}
                      </span>
                    </p>
                  </div>
                </div>
              </CardBody>
            </div>
            <div
              style={{
                borderTop: "0.75px dashed #DBDBDB",
                margin: "10px 0",
              }}
            ></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                marginRight: "10px",
              }}
            >
              <div>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      marginRight: "30px",
                      lineHeight: "10px",
                      fontSize: "13px",
                    }}
                  >
                    Face Match
                  </strong>
                  <span>
                    {" "}
                    {bankSelfieData?.bankDetails?.facematchScore || "-------"}
                  </span>
                </p>
              </div>
              <div>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "13px",
                    }}
                  >
                    Face Liveness
                  </strong>
                  <span>
                    {bankSelfieData &&
                    bankSelfieData.selfieDetails &&
                    bankSelfieData.selfieDetails.faceLivenessScore
                      ? `${
                          Math.round(
                            (bankSelfieData.selfieDetails.faceLivenessScore +
                              Number.EPSILON) *
                              10000
                          ) / 100
                        } %`
                      : "-------"}
                    {bankSelfieData &&
                    bankSelfieData.selfieDetails &&
                    Math.round(
                      (bankSelfieData.selfieDetails.faceLivenessScore +
                        Number.EPSILON) *
                        10000
                    ) /
                      100 <
                      65 ? (
                      <span style={{ marginLeft: "1em" }}>
                        <Button color="danger">Reject</Button>
                      </span>
                    ) : null}
                  </span>

                  {/* <span>
                 {bankSelfieData?bankSelfieData.selfieDetails?`${(Math.round((bankSelfieData.selfieDetails.faceLivenessScore+Number.EPSILON)*10000)/100)} %`:null:null}
              </span> */}
                </p>
              </div>
              <div>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "13px",
                    }}
                  >
                    Name Match
                  </strong>
                  <span>
                    {bankSelfieData &&
                    bankSelfieData.bankDetails &&
                    bankSelfieData.bankDetails.matchPercentage
                      ? `${bankSelfieData.bankDetails.matchPercentage} %`
                      : "-------"}
                  </span>
                </p>
              </div>
            </div>
          </Card>
        ) : null
      ) : null}
    </div>
  );
}
